import { personSearch } from '@api/person/person-search.api';
import { makeLoader, normalizeForLoader } from '@lib/common';
import DataLoader from 'dataloader';
import { map } from 'rxjs/operators';

export const personDataLoader = new DataLoader(
  (ids: string[]) =>
    personSearch({ searchKey: 'vtr_id', query: ids.join(',') })
      .pipe(
        map(d => d.data.data),
        normalizeForLoader(ids, p => p.vtr_id)
      )
      .toPromise(),
  {
    maxBatchSize: 15,
  }
);

export const usePersonLoader = makeLoader(personDataLoader);
